import {SignatureErrorModel} from '../../models/api/signatureModel';

export class SignaturesError extends Error {
  constructor(error: SignatureErrorModel) {
    super(error.message);
    this.name = 'SignaturesError';
  }
}
